import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4a9fa86"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "section",
  id: "resume"
}
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title is-2" }, "Resumo", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "subtitle is-5" }, "Meu currÍculo em PDF", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-alt" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Download", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generateDownloadLink && _ctx.generateDownloadLink(...args))),
        class: "button button-color-default is-medium"
      }, _hoisted_7)
    ])
  ]))
}